import _ from "lodash";


export default defineNuxtPlugin(() => {
  if (import.meta.server) return;

  const authStore = useAuthStore();

  const handleSessionExpired = _.debounce(() => {
    if (!authStore.isAuthenticated) return;
    authStore.logout();
    showInfoNotification("Your session has expired. Please log in again.");
  }, 100);

  window.addEventListener("umi:session-expired", handleSessionExpired);
});
